import { ChatTitleProps } from "../types"
import React from "react"
import Icon from "~widgets/icon"
import styled, { useTheme } from '~/ui/styled'
import { Flex } from "~components/El"
// import { Tag } from "~components"
const Container = styled(Flex)`
  flex-direction: row;
  align-items: center;
`

const Text = styled.Text`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
  font-weight: 600;
  max-width: 240px;
`

// 聊天标题
const ChatTitle: React.FC<ChatTitleProps> = ({ title, chatTypeEnum, count, isMute }) => {
const theme = useTheme()
  return (
    <Container>
      {chatTypeEnum === "CHANNEL" && <Icon name="pdbs" size={12} color={theme.colors.purpleBackground} />}
      <Text numberOfLines={1}>
        {title}
        {count > 0 && `(${count})`}
      </Text>
      {isMute && <Icon name="tzg" size={15} color={theme.colors.warning} />}
    </Container>
  )
}

export default ChatTitle
